import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import Image from 'next/image';

export const MessageSender = () => {
  const { t } = useTranslation();
  return (
    <Box gap="3px" verticalAlign="middle">
      <Image src="https://static.parastorage.com/services/kb-client-nextjs/dist/public/images/icons/sparkles.svg" alt="ai" width={24} height={24} />
      <Text size="small">{t('article-page.copilot.chatbot')}</Text>
    </Box>
  );
};

